export default "__VITE_ASSET__CbvmVlXT__"